/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var EditFillIcon = function EditFillIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M21.1526 3.06053C22.5194 4.42736 22.5194 6.64344 21.1526 8.01027L20.7989 8.36392L15.8492 3.41417L16.2028 3.06053C17.5697 1.69369 19.7857 1.69369 21.1526 3.06053Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.435 4.82839L19.3847 9.77814L8.81507 20.3478C8.58794 20.5749 8.30943 20.744 8.00312 20.8407L3.06892 22.3989C2.71317 22.5112 2.32447 22.4162 2.06068 22.1524C1.79689 21.8886 1.70186 21.4999 1.8142 21.1442L3.37238 16.21C3.46911 15.9037 3.63819 15.6252 3.86533 15.398L14.435 4.82839Z"
  }));
};
export default EditFillIcon;